export default {
    "sv-SE": {
        //Headings
        what_is_heading: "vad är SenseView?",
        how_heading: "hur funkar det?",
        background_heading: "bakgrund",
        price_heading: "priser",
        try_heading: "testa",
        team_heading: "teamet",
        our_call_heading: "vår uppmaning",

        //UI
        more_info: "mer info",
        month: "månad",
        contact_us: "kontakta oss",

        //Pricing
        sensors: "sensorer",
        user_accounts: "användarkonton",
        up_to: "upp till",
        unlimited: "obegränsade",
        map_requests: "kartvisningar",
        brand: "egenbrandade vyer (logga)",
        alarm_feature: "larmfunktion / regelmotor",
        further_integration: "för vidare integration",
        secure_cloudstorage: "säker molnlagring inom",
        data_export: "fri export av data vid behov",
        personal_contact_pilot: "personlig kontakt för hjälp med piloter",
        maintenance_development: "underhåll och vidareutveckling",
        pricing_button: "kontakta oss för 30 dagars kostnadsfri testperiod*",
        pricing_information: "*När din testperiod är slut faktureras licensen kvartalsvis men kan alltid sägas upp med en månads varsel.",

        //Non visibles
        email_subject: "intresserad av SenseView",

    },
    "en-US": {
        //Headings
        what_is_heading: "what is SenseView?",
        how_heading: "how does it work?",
        background_heading: "background",
        price_heading: "pricing",
        try_heading: "try it out",
        team_heading: "the team",
        our_call_heading: "our call",

        //UI
        more_info: "more info",
        month: "month",
        contact_us: "contact us",

        //Non visibles
        email_subject: "interested in SenseView",
    }
};


// WEBPACK FOOTER //
// ./src/translations.ts